import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import Title from 'components/Title';
import './styles.scss';
import StepCard from 'components/StepCard';
import { history } from 'util/helpers/history';

class ChooseAccount extends Component {
  render() {
    return (
      <StepCard
        onPrevious={() => history.goBack()}
        id="buy.vignete.instruction.title"
        className="extend-vignette-choice"
        current={1}
        steps={7}
      >
        <Title id="buy.vinget.instruction.item.2" />
        <Row type="flex" justify="center" gutter={24}>
          <Col xs={24} sm={24} lg={10} className="img-center-column">
            <p style={{ marginTop: '25%' }}>
              <FormattedHTMLMessage id="buy.vignet.account.description" />
            </p>
          </Col>
          <Col lg={1} xs={0} className="img-border-divider"></Col>
          <Col sm={24} xs={20} lg={10}>
            <div
              onClick={() => history.push('/buy/vignette/annual/login')}
              style={{ cursor: 'pointer' }}
            >
              <img
                alt="renew vignette"
                className="main-icons"
                src={require('assets/no_account.svg')}
              />
              <FormattedMessage id="buy.vignet.have.account" />
            </div>
            <div
              onClick={() => history.push('/buy/vignette/annual/register')}
              style={{ cursor: 'pointer' }}
            >
              <img
                alt="cancel vignette"
                className="main-icons"
                src={require('assets/has_account.svg')}
              />
              <FormattedMessage id="buy.vignet.no.account" />
            </div>
          </Col>
        </Row>
      </StepCard>
    );
  }
}

ChooseAccount.propTypes = {
  isloading: PropTypes.bool,
  goToActivateVignette: PropTypes.func.isRequired,
  goToExtendVignette: PropTypes.func.isRequired,
};

export default ChooseAccount;
